<template>
  <div class="read-only-wrapper">
    <div class="__label">
      {{ label }}
    </div>
    <div class="__value">
      <template v-if="customValue">
        <slot name="customValue"></slot>
      </template>
      <template v-else>
        {{ value }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReadOnly',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '-',
    },
    customValue: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.read-only-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .__label {
    color: $mep-color-text-300;
  }

  .__value {
    font-weight: 500;
  }
}
</style>
